import { useUserProvider } from '@wt/game/providers/user/UserProvider';
import { getSiteMode } from '@wt/utilities/siteMode';

// Desktop only
export const SidebarAd = () => {
  const { user } = useUserProvider();

  if (user.isPremium) {
    return <></>;
  }

  return (
    <div
      className="hidden lg:flex ipad:h-[110px] ipad:w-full desktop:h-[600px] desktop:w-[390px] overflow-y-auto"
      style={{ maxHeight: 'calc(100vh - 210px)' }}
    >
      {getSiteMode() != 'whentaken-movies' && <div id="adngin-sidebar-0"></div>}
      {getSiteMode() == 'whentaken-movies' && <div id="adngin-side_1-0"></div>}
    </div>
  );
};
